export const mutations = {
  setEstado(state, data) {
    state.estado = data;
  },
  setEstados(state, data) {
    state.estados = data;
  },
};

export default {};
